export default "__VITE_ASSET__B57xqOfw__"